module.exports = __webpack_public_path__ + "img/zy-logo2.7b4f1ead.png";